export const TITLE_SKELETON_LINE_HEIGHT_PX = 16;

export const TITLE_SKELETON_CORNER_RADIUS = '4px';
